import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'persons/employment';
const wizardName = 'Car dissociation';
const wizardObject = 'Car';
const wizardAction = 'carDissociation';

const CarDissociation = (params) => {
    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);


    // DATA PROVIDER
    const {doAction, item, loadOne, errorMessage, errors, saving} = useDataProvider(dataProviderName, params.multipart);

    let dsvs = params.defaultSelectedValues;
    if (typeof dsvs == 'string') {
        dsvs = dsvs.split(',').map((dsv) => { return {'_id': dsv}});
    } else if (typeof dsvs == 'undefined') {
        dsvs = [];
    } else{
        dsvs = [dsvs];
    }

    const modelName = existingModules[dataProviderName].modelName
    const employmentId = item?.data?._id ?? item?.data?.id;

    const detailConfig = useMemo(() => ({
        "tabs": [
            {
                "name": "dissociation",
                "fieldsets": [
                    {
                        "name": "dissociation",
                        "fields": {
                            "assignment_period": {
                                "type": "sectiontitle",
                                "className": "col-12"
                            },
                            "assignment_end_at": {
                                "type": "date",
                                "className": "col-12",
                                "placeholder": "insert",
                                "icon": "faCalendarXmark"
                            },
                            "cars_assigned": {
                                "type": "sectiontitle",
                                "className": "col-12"
                            },
                            "dissociated": {
                                "type": "poollist",
                                "defaultSelectedValues": dsvs,
                                "enableSelection": true,
                                "disableMultipleRowSelection": true,
                                "hideTableToolbar": true,
                                "dataProviderName": "cars/pool",
                                "filters": employmentId ? {
                                    "items": [
                                        {
                                            "field": "employment_id",
                                            "operator": "equals",
                                            "value": employmentId,
                                        },
                                        {
                                            "field": "assignment_end_at",
                                            "operator": "isEmpty",
                                        },
                                    ],
                                } : { "items": [] },
                                "className": "col-12",
                                "required": "true"
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }), [employmentId, dsvs]);
    const handleSave = async (data) => {
        doAction && await doAction({ action: wizardAction, model: dataProviderName, data: data });
        loadOne( item?.data?._id )
        close();
    }

    return <>
        <DetailComponent
            disableDetailConfigOverride={true}
            values={{ "id": item?.data?._id, "dissociated": dsvs?.map((dsv) => dsv._id) }}
            modelName={modelName}
            detailConfig={detailConfig}
            dataProviderName={dataProviderName}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={userCapabilities && userCapabilities[dataProviderName+'.'+wizardAction.toLowerCase()]}
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t('Remove a {{wizardObject}} from {{firstname}} {{lastname}}', { wizardObject:wizardObject, firstname: item.data.firstname, lastname: item.data.lastname })}
                />
            }
            {...params}
        />
    </>
}

export default CarDissociation;


